module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_7016.ed38f7e1.png";